import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-neu-full px-2.5 py-0.5 text-xs font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-luvcorp-gold/50",
  {
    variants: {
      variant: {
        default:
          "neu-badge",
        secondary:
          "bg-luvcorp-gold/15 text-luvcorp-navy border border-luvcorp-gold/30 shadow-neu-outset-sm",
        destructive:
          "bg-red-500/10 text-red-700 border border-red-500/30 shadow-neu-outset-sm",
        outline: "neu-badge",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
